import { render, staticRenderFns } from "./agriService.vue?vue&type=template&id=ae27ad9c&scoped=true"
import script from "./agriService.vue?vue&type=script&lang=js"
export * from "./agriService.vue?vue&type=script&lang=js"
import style0 from "./agriService.vue?vue&type=style&index=0&id=ae27ad9c&prod&lang=less&scoped=true"
import style1 from "./agriService.vue?vue&type=style&index=1&id=ae27ad9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae27ad9c",
  null
  
)

export default component.exports